/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import { IUser } from 'app/shared/model/user.model';
import { IContactDetails } from 'app/shared/model/contact-details.model';
import { StoreType } from 'app/shared/model/enumerations/store-type.model';

export interface IPharmacy {
  id?: string;
  name?: string;
  createdDtm?: number | null;
  createdBy?: string;
  timestampEntry?: number;
  microSec?: number;
  lastUpdated?: number;
  active?: boolean;
  cursor?: number;
  registrationCode?: string;
  registrationAuth?: string;
  registrationState?: string;
  email?: string;
  returnInstructions?: string | null;
  taxCode?: string | null;
  billPrefix?: string | null;
  storeType?: keyof typeof StoreType | null;
  user?: IUser;
  contactCode?: IContactDetails;
}

export const defaultValue: Readonly<IPharmacy> = {
  active: false,
};
